/** Canonical Socket.IO events for realtime call queue updates. */
export const SocketEvents = {
  identify: "identify",
  pong: "pong",
  ping: "ping",
  callIncoming: "call:incoming",
  callIncomingEnriched: "call:incoming:enriched",
  callTaken: "call:taken",
  callSnapshot: "call:snapshot",
  callEnded: "call:ended",
  callEvent: "call:event",
  callAnswered: "call:answered",
  queueClaimed: "queue:claimed",
  queueClaimReleased: "queue:claim-released",
  callObserverJoined: "call:observer-joined",
  callObserverLeft: "call:observer-left",
  callOperatorLeft: "call:operator-left",
  agentList: "agent:list",
  agentStatus: "agent:status",
  inviteConference: "invite:conference",
} as const;

export type SocketEventName = (typeof SocketEvents)[keyof typeof SocketEvents];
